<script setup lang="ts">

const { initScroller, setupScrollers } = useMenuScroller()

</script>

<template>
  <div class="container relative hidden lg:block">
    <button 
      data-scroll-left 
      class="absolute h-[48px] w-[48px] flex items-center justify-center left-0 top-0 -mt-[48px] bg-white/90 p-2 rounded-r hidden hover:text-primary" 
      :aria-label="$t('header.ariaLabelScrollMenuLeft')">
      <i class="icon-chevron-right font-bold rotate-180 text-base"></i> 
    </button>

    <button 
      data-scroll-right 
      class="absolute h-[48px] w-[48px] flex items-center justify-center right-0 top-0 -mt-[48px] bg-white/90 p-2 rounded-l hidden hover:text-primary" 
      :aria-label="$t('header.ariaLabelScrollMenuRight')">
      <i class="icon-chevron-right font-bold text-base"></i> 
    </button>
  </div>
</template>
